import { Card } from "@/components/ui/card";
import { useTranslations } from "@/components/context/translations";

export function AlreadyDelayed() {
  const t = useTranslations();

  return (
    <div className="flex flex-col items-center">
      <Card className="mt-40 text-center">
        <h1 className="text-lg font-semibold mb-4">{t("Thank you!")}</h1>
        <p className="leading-relaxed">
          {t("You have already told us why you haven't tried your sample yet.")}
        </p>
      </Card>
    </div>
  );
}
